import { Box } from '@mui/material';
import { ReactComponent as Home } from '../../../assets/home-icon.svg';
import { Button } from './home-button.styles';

const HomeButton = ({ onClick }: { onClick: () => void }) => {
    return (
        <Button onClick={onClick} variant="outlined" color="primary">
            <Home height={30} />
            <Box width={10} />
            Home
        </Button>
    );
};

export default HomeButton;
